//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
export default {
  name: 'LandingLastNews',
  data () {
    return {
      showSlider: false
    }
  },
  computed: {
    ...mapGetters({
      news: 'coins/news'
    })
  },
  methods: {
    openTab () {
      const routeData = this.$router.resolve({ path: '/my/auth/register' })
      window.open(routeData.href, '_blank')
    }
  }
}
